import { z } from 'zod';

export const productArticleSchema = z
    .string()
    .trim()
    .regex(/^[A-Za-z0-9]{7}$/, 'артикул должен быть ровно 7 символов');
